import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedDate } from 'react-intl';

import { ArchiveContext } from '../../archive-context';
import { messages } from '../../messages';
import style from '../../style.module.less';

const ArchiveDateColumn = ({ archiveId }) => {
  const { archives } = useContext(ArchiveContext);
  const month = archives[archiveId]?.month;
  const monthNumber = month ? month - 1 : 0;
  const year = archives[archiveId]?.year ?? 0;

  return (
    <div className={style['item-cell']}>
      <FormattedDate month='long' value={new Date(year, monthNumber)} year='numeric' />
    </div>
  );
};

ArchiveDateColumn.propTypes = {
  archiveId: PropTypes.string.isRequired,
};

export default {
  getMessageDescriptor: () => <FormattedMessage {...messages.archiveMonth} />,
  id: 'archiveDate',
  render: ArchiveDateColumn,
};
